<mat-dialog-content>
    <h1 class="text-black text-2xl mb-4">Agregar Proveedor</h1>
    <form [formGroup]="providerForm" (ngSubmit)="handleCreateProvider()" class="space-y-4">
        <div class="flex flex-col">
            <label for="id" class="text-gray-700">ID</label>
            <input id="id" matInput type="text" [(ngModel)]="newProvider.id" formControlName="id"
                placeholder="Ingrese el ID del proveedor"
                class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
            <mat-error *ngIf="providerForm.get('id')?.hasError('required')">El ID es requerido</mat-error>
        </div>
        <div class="flex flex-col">
            <label for="name" class="text-gray-700">Nombre</label>
            <input id="name" matInput type="text" formControlName="name" placeholder="Ingrese el nombre del proveedor"
                class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
            <mat-error *ngIf="providerForm.get('name')?.hasError('required')">El nombre es requerido</mat-error>
        </div>
        <div class="flex flex-col">
            <label for="type" class="text-gray-700">Tipo</label>
            <mat-select id="type" formControlName="type" placeholder="Seleccione el tipo del proveedor"
                class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
                <mat-option value="non_monetic">No Monético</mat-option>
                <mat-option value="monetic">Monético</mat-option>
            </mat-select>
            <mat-error *ngIf="providerForm.get('type')?.hasError('required')">El tipo es requerido</mat-error>
        </div>
        <div class="flex flex-col">
            <label for="status" class="text-gray-700">Estado</label>
            <mat-select id="status" formControlName="status" placeholder="Seleccione el estado del proveedor"
                class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
                <mat-option value="active">Activo</mat-option>
                <mat-option value="inactive">Inactivo</mat-option>
            </mat-select>
            <mat-error *ngIf="providerForm.get('status')?.hasError('required')">El estado es requerido</mat-error>
        </div>
        <div class="flex flex-col">
            <label for="complexity" class="text-gray-700">Complejidad</label>
            <mat-select id="complexity" formControlName="complexity" placeholder="Seleccione el estado del proveedor"
                class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
                <mat-option value="simple">Simple</mat-option>
                <mat-option value="complex">Compleja</mat-option>
            </mat-select>
            <mat-error *ngIf="providerForm.get('complexity')?.hasError('required')">La complejidad es
                requerida</mat-error>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="justify-between">
    <button class="bg-orange-400 hover:bg-orange-500 text-white font-bold py-2 px-4 mb-3 rounded" mat-button
        type="submit" [disabled]="!providerForm.valid" (click)="handleCreateProvider()">Agregar Proveedor</button>
    <button class="bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 mb-3 ml-5 rounded" mat-button
        (click)="closeModal()">Cancelar</button>
</mat-dialog-actions>